import React from 'react';

import Select from 'react-select';

interface CustomSelectProps {
    options : [{
        value : string,
        label : string,
        disbaled? : boolean
    }],
    onChange: (e : any) => any,
    value : any
}

const CustomSelect =  ({options, onChange, value} : CustomSelectProps) => (
  <Select
    defaultValue={options.slice(0,4)}
    isMulti
    name="colors"
    options={options}
    className="basic-multi-select text-slate-800 w-full max-w-2xl mt-3"
    onChange={onChange}
    value={value}
    isOptionDisabled={(option) => !option.disabled}
  />
);

export default CustomSelect;